<app-main-layout
  [clickNext]="onClickNext"
  [clickBack]="onClickBack"
  [activateNextButton$]="nextButtonState.activateNext$"
  >
  <div class="main-heading">
    <h2>What are you replacing?</h2>
  </div>
  <div class="images-block">
    @if (currentImage) {
      <img
        width="278"
        height="160"
        [src]="currentImage"
        alt="Image"
        class="brand-icon"
        />
    }
    @if (isDoorHighlighted) {
      <div class="door">
        <svg width="278" height="160" viewBox="0 0 278 160" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_253_3873)">
            <path d="M177.476 130.563H190.648C191.606 130.563 192.382 131.338 192.382 132.294V159.654H175.743V132.294C175.743 131.338 176.519 130.563 177.476 130.563Z" fill="white" stroke="var(--brand-accent)"/>
            <path d="M189.955 147.186C190.529 147.186 190.995 146.721 190.995 146.147C190.995 145.573 190.529 145.108 189.955 145.108C189.381 145.108 188.915 145.573 188.915 146.147C188.915 146.721 189.381 147.186 189.955 147.186Z" fill="white" stroke="var(--brand-accent)"/>
          </g>
          <defs>
            <clipPath id="clip0_253_3873">
              <rect width="278" height="160" fill="white"/>
            </clipPath>
          </defs>
        </svg>
      </div>
    }
  </div>
  <div class="counter-block-frame">
    <app-counter
      class="counter-input"
      [step]="windows.counterStep"
      [min]="windows.counterMinValue"
      [max]="windows.counterMaxValue"
      [initialValue]="windows.counterInitialValue"
      type="windows"
      label="Number of Windows"
      (valueChange)="onCounterValueChange($event, 'windows')"
      >
    </app-counter>
    <app-counter
      class="counter-input"
      [step]="doors.counterStep"
      [min]="doors.counterMinValue"
      [max]="doors.counterMaxValue"
      type="doors"
      label="Number of Doors"
      [initialValue]="doors.counterInitialValue"
      (valueChange)="onCounterValueChange($event, 'doors')"
      >
    </app-counter>
  </div>

</app-main-layout>
